
const Redirect = {

  el: {
    dropdown: document.querySelectorAll("[data-action='redirect']"),
  },

  init: () => {
    Redirect.el.dropdown.forEach((redirect) => {
      redirect.addEventListener("change", Redirect.handleRedirect);
    });
  },

  handleRedirect: (event) => {
    document.location = event.target.value;
  },
};

export default Redirect;
